<template>
  <section>
    <LoadingSpinner v-if="loading" />

    <!-- Tabs de Attention / OK (solo para CriticalOperatingMargin) -->
    <div v-if="!loading && condition === 'CriticalOperatingMargin'" class="mb-3">
      <ul class="nav nav-tabs">
        <li class="nav-item">
          <a
            class="nav-link"
            :class="{ active: activeTab === 'attention' }"
            href="#"
            @click.prevent="activeTab = 'attention'"
          >
            <span class="text-danger font-weight-bold">
              ⚠ Attention ({{ ordersAttention.length }})
            </span>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            :class="{ active: activeTab === 'ok' }"
            href="#"
            @click.prevent="activeTab = 'ok'"
          >
            ✓ OK ({{ ordersOk.length }})
          </a>
        </li>
      </ul>
    </div>

    <!-- Table (list orders) + -->
    <div class="mx-0 px-0 table-responsive">
      <Table
        v-if="!loading && !showEmptyImage"
        class="mx-0 w-100"
        :headers="currentHeaders"
        :cols="currentCols"
        :data="currentOrders"
        :checkbox="false"
        :notselect="true"
        :model="model"
        :fieldsLoading="fieldsLoading"
        :key="captainkey"
        @editOrder="editOrder"
        @openTarget="openTarget"
        @openClient="openClient"
        @openComments="openComments">
      </Table>
    </div>

    <!-- Modal de comentarios -->
    <Comments
      v-if="condition === 'CriticalOperatingMargin'"
      modal-name="com-order-comments-modal"
      :client="selectedOrderForComments"
      :notes="commentsNotes"
      :visible="commentsModalVisible"
      :loading="commentsLoading"
      @publish="publishNote"
      @close="commentsModalVisible = false"
    />
  </section>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { targetsService, usersService } from "@/_services";
import Table from "@/components/Common/Table.vue";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import Comments from "@/components/Common/Comments.vue";

export default {
  computed: {
    ...mapState({
      currentUser: (state) => state.authentication.user,
      isMenuCollapse: (state) => state.sidebar.isNavOpen,
      filtersSystem: (state) => state.campaigns.filtersSystem,
    }),
    ordersPreparingAndNotVerified() {
      return this.ordersStatus.filter(
        (el) => el.target_status_id === "1" && el.target_validation === "0"
      );
    },
    ordersPreparingAndVerified() {
      return this.ordersStatus.filter(
        (el) =>
          el.target_status_id === "1" &&
          el.target_validation === "1" &&
          parseInt(el.prospectors_active) > 3
      );
    },
    ordersAttention() {
      return this.orders.filter(o => o.time_warning == '1' || o.time_warning === 1);
    },
    ordersOk() {
      return this.orders.filter(o => o.time_warning != '1' && o.time_warning !== 1);
    },
    currentOrders() {
      if (this.condition !== 'CriticalOperatingMargin') return this.orders;
      return this.activeTab === 'attention' ? this.ordersAttention : this.ordersOk;
    },
    currentCols() {
      if (this.condition !== 'CriticalOperatingMargin') return this.cols;
      return this.colsWithComment;
    },
    currentHeaders() {
      if (this.condition !== 'CriticalOperatingMargin') return this.headers;
      return this.headersWithComment;
    },
  },

  data() {
    return {
      filters: [],
      filterkey: 2233,
      ordersStatus: [],
      fieldsLoading: true,
      sort: "",
      dir: "",
      keyFilter: 1,
      searchFilter: {},
      oldQuery: "  ",
      orderStatus: 10,
      loading: true,
      typelist: 10,
      typelistPreparing: 10,
      filterColumn: [],
      orders: [],
      showEmptyImage: false,

      captainkey: 112000,
      model: {
        imported: false,
        refreshlist: false,
        selectfirst: false,
        cantPerPage: 25,
        currentPage: 1,
      },
      cols: [
        [
          {
            value: "task_open_hours",
            type: 'time',
          },
        ],
        [
          {
            value: "created",
          },
        ],
        [
          {
            value_label: "target_name",
            value_emit: "id",
            class: "text-primary",
            textShort: 40,
            type: "emit",
            emit: "openTarget",
            badges: [
              {
                badge_if: "stats",
                badge_value: "2",
                badge_class: "badge badge-danger text-white",
                badge_label: this.$t("lang.label.nonverified"),
                badge_tooltip: this.$t("lang.label.refused_tooltip"),
              },
              {
                badge_if: "stats",
                badge_value: "1",
                badge_class: "badge badge-success text-white",
                badge_label: this.$t("lang.label.verified"),
                badge_tooltip: this.$t("lang.label.approved_tooltip"),
              },
              {
                badge_if: "stats",
                badge_value: "0",
                badge_class: "badge badge-secondary text-white",
                badge_label: this.$t("lang.label.unverified"),
                badge_tooltip: this.$t("lang.label.unverified_tooltip"),
              },
            ],
          },
        ],
        [
          {
            value: "duplicate_reason",
          },
        ],
        [
          {
            value_emit: "id",
            value: "target_status_id",
            // class: "text-primary",
            type: "emit",
            emit: "editOrder",
            badges: [
              {
                badge_if: "target_status_id",
                badge_value: "1",
                badge_class: "badge badge-primary text-white",
                badge_label: this.$t("lang.targets.active"),
                badge_tooltip: this.$t("lang.orders.status_prepare_tooltip"),
              },
              {
                badge_if: "target_status_id",
                badge_value: "2",
                badge_class: "badge badge-danger text-white",
                badge_label: this.$t("lang.targets.stopped"),
                badge_tooltip: this.$t("lang.orders.status_inactive_tooltip"),
              },
              {
                badge_if: "target_status_id",
                badge_value: "3",
                badge_class: "badge badge-secondary text-white",
                badge_label: this.$t("lang.targets.pending"),
                badge_tooltip: this.$t("lang.orders.status_draft_tooltip"),
              },
              {
                badge_if: "target_status_id",
                badge_value: "4",
                badge_class: "badge badge-success text-white",
                badge_label: this.$t("lang.targets.running"),
                badge_tooltip: this.$t("lang.orders.status_active_tooltip"),
              },
              {
                badge_if: "target_status_id",
                badge_value: "5",
                badge_class: "badge badge-warning text-white",
                badge_label: this.$t("lang.targets.archived"),
                badge_tooltip: this.$t("lang.orders.status_achived_tooltip"),
              },
            ],
          },
        ],
        [
          {
            value: "name",
          },
        ],
        [
          {
            value: "launch_date_campaign",
          },
        ],
        [
          {
            value: "prospecting_days",
          },
        ],
        [
          {
            value_label: "client_name",
            value_emit: "client_id",
            class: "text-primary",
            type: "emit",
            emit: "openClient",
          },
        ],
        [
          {
            value: "total",
          },
        ],
        [
          {
            value: "id",
            type: "campaignsBadge",
            formatNumber: "true",
            //loading: "false",
          },
        ],
        [
          {
            value: "id",
            type: "statsBadge",
          },
        ],
        [
          {
            value: "profitability",
          },
        ],
        [
          {
            value: "cashable_margin",
          },
        ],
        [
          {
            value: "operating_margin",
          },
        ],
        [
          {
            value: "global_margin",
          },
        ],
        [
          {
            value: "total_cold_call_tasks",
          }
        ]
      ],
      headers: [
        {
          label: 'Time',
          percentage: "12.5%",
          class: "overflowhide",
          permission: "adminClients",
          id: 11,
        },
        {
          label: this.$t("lang.column.creation"),
          percentage: "10.5%",
          class: "overflowhide",
          permission: "AgencyBilling",
          id: 1,
        },
        {
          label: this.$t("lang.column.name"),
          percentage: "10.5%",
          class: "overflowhide",
          permission: "AgencyBilling",
          id: 1,
        },
        {
          label: this.$t("lang.column.duplicate_reason"),
          percentage: "10.5%",
          class: "overflowhide",
          permission: "AgencyBilling",
          id: 1,
        },
        {
          label: this.$t("lang.column.status"),
          percentage: "12.5%",
          class: "overflowhide",
          permission: "AgencyBilling",
          id: 2,
        },
        {
          label: this.$t("lang.column.owner"),
          percentage: "12.5%",
          class: "overflowhide",
          permission: "AgencyBilling",
          id: 3,
        },
        {
          label: this.$t("lang.column.launch_date"),
          percentage: "12.5%",
          class: "overflowhide",
          permission: "AgencyBilling",
          id: 12,
        },
        {
          label: this.$t("lang.column.prospecting_days"),
          percentage: "12.5%",
          class: "overflowhide",
          permission: "AgencyBilling",
          id: 3,
        },
        {
          label: this.$t("lang.column.client"),
          percentage: "12.5%",
          class: "overflowhide",
          permission: "adminClients",
          id: 11,
        },
        {
          label: "3D AVG First Contact",
          class: "overflowhide",
        },
        {
          label: this.$t("lang.label.prospectingemails"),
          percentage: "12.5%",
          class: "",
          id: 6,
          permission: "adminClients",
        },
        {
          label: this.$t("lang.label.statistics"),
          class: "overflowhide",
          permission: "adminClients",
          id: 16,
        },
       {
          label: 'Profitability',
          percentage: "12.5%",
          class: "text-danger",
          permission: "adminClients",
          id: 11,
        },
        {
          label: 'Cashable Margin',
          percentage: "12.5%",
          class: "overflowhide",
          permission: "adminClients",
          id: 11,
        },
        {
          label: 'Operating Margin',
          percentage: "12.5%",
          class: "overflowhide",
          permission: "adminClients",
          id: 11,
        },
        {
          label: 'Global Margin',
          percentage: "12.5%",
          class: "overflowhide",
          permission: "adminClients",
          id: 11,
        },
        {
          label: 'Cold Call tasks done',
          percentage: "12.5%",
          class: "overflowhide",
          permission: "adminClients",
          id: 11,
        }
      ],
      getOrderNumber: 0,
      responseOrderNumber: 0,
      // Tabs para CriticalOperatingMargin
      activeTab: 'attention',
      // Modal de comentarios
      selectedOrderForComments: null,
      commentsNotes: [],
      commentsModalVisible: false,
      commentsLoading: false,
      // Cols/headers con columna de comentario
      colsWithComment: null,
      headersWithComment: null,
    };
  },
  components: {
    Table,
    LoadingSpinner,
    Comments,
  },

  mounted() {
    this.loadOrders();
    this.udpdateHeader(this.$route.name);
    this.setCurrentRouteChild({ child: "" });
    // Construir cols/headers con comentario (después de la columna Time)
    this.colsWithComment = [
      this.cols[0],
      [{ value: 'id', type: 'commentIcon', value_emit: 'id', emit: 'openComments' }],
      ...this.cols.slice(1),
    ];
    this.headersWithComment = [
      this.headers[0],
      { label: '', percentage: '3%', class: '' },
      ...this.headers.slice(1),
    ];
  },

  props: {
    client_id: {
      type: Number,
      default: undefined,
    },
    fromClient: {
      type: Boolean,
      default: false,
    },
    condition: {
      type: String,
      default: null
    },
    tabId: {
      type: String,
      required: true
    },
    oliver_sale_id: {
      type: String,
      required: '0',
    },
    showTotals: {
      type: Boolean,
      default: false
    },
    month: {
      type: String,
      default: '0'
    }
  },

  watch: {
    oliver_sale_id(newVal, oldVal) {
      if (newVal != oldVal) {
        this.loadOrders();
      }
    },
    tabId (value) {
      this.loadOrders();
    }
  },

  methods: {
    ...mapActions("headertopbar", {
      setCurrentRoute: "setRoute",
      setCurrentRouteChild: "setRouteChild",
    }),
    udpdateHeader(route) {
      this.setCurrentRoute({ page: route });
    },
    hasPermissions(perm) {
      return this.$store.getters["authentication/hasPermissions"](perm);
    },
    getColdTaskByOrders(orderIds) {
      targetsService.getColdCallTaskByTargets(orderIds)
        .then((response) => {
          const coldTasks = Array.isArray(response)
            ? response
            : (Array.isArray(response && response.result) ? response.result : []);

          const tasksByTargetId = coldTasks.reduce((acc, item) => {
            acc[String(item.target_id)] = item.total_cold_call_tasks;
            return acc;
          }, {});

          this.orders = this.orders.map((order) => {
            if (!order.id) {
              return order;
            }
            const total = tasksByTargetId[String(order.id)];
            return {
              ...order,
              total_cold_call_tasks: total !== undefined ? total : "",
            };
          });

          this.captainkey += 1;
          this.loading = false;
        })
        .catch((error) => {
          console.log("Error getting cold call task by orders:", error);
          this.loading = false;
        });
    },
    loadOrders(order, filter = []) {
      this.loading = true;
      targetsService.getTargetListToProfitability(this.tabId, 0, this.condition, this.oliver_sale_id, this.month)
        .then((response) => {
        if (response !== undefined) {

          //Calculos para los totales o resultados, para la ultima final
          if(response.result.length > 0 && this.showTotals){
            const prospecting_day_total = response.result.reduce((sum, item) => sum + Number(item.prospecting_days), 0);
            const prospecting_days = prospecting_day_total / response.result.length;

            const prospectors_active = response.result.reduce((sum, item) => sum + Number(item.prospectors_active), 0);
            const total_contacted_contacts = response.result.reduce((sum, item) => sum + Number(item.total_contacted_contacts), 0);
            const total_email_sent = response.result.reduce((sum, item) => sum + Number(item.total_email_sent), 0);

            const meet_rate = response.result.reduce((sum, item) => sum + Number(item.meeting_rate), 0);
            const meeting_rate = meet_rate / response.result.length;

            const total_meetings = response.result.reduce((sum, item) => sum + Number(item.total_meetings), 0);
            const total_amount = response.result.reduce((sum, item) => sum + Number(item.total_amount), 0);

            const profitability = response.result.reduce((sum, item) => sum + Number(item.profitability), 0);

            const cashable_margin_total = response.result.reduce((sum, item) => sum + Number(item.cashable_margin), 0);
            const cashable_margin = cashable_margin_total / response.result.length;

            const operating_margin_total = response.result.reduce((sum, item) => sum + Number(item.operating_margin), 0);
            const operating_margin = operating_margin_total / response.result.length;

            const global_margin_total = response.result.reduce((sum, item) => sum + Number(item.global_margin), 0);
            const global_margin = global_margin_total / response.result.length;


            response.result.push({
                created: "",
                target_name: "",
                target_status_id: "0",
                prospecting_days: prospecting_days,
                cashable_margin: cashable_margin.toFixed(2),
                operating_margin: operating_margin.toFixed(2),
                global_margin: global_margin.toFixed(2),
                total: "",
                name: "",
                client_id: "",
                launch_date_campaign: "",
                id: "",
                client_name: "",
                duplicate_reason: "",
                profitability: profitability.toFixed(2),
                total_revenue: "",
                task_open_hours: "",
                prospectors_total: "2",
                prospectors_warmingup: "0",
                prospectors_active: prospectors_active,
                prospectors_resting: "0",
                stats: "",
                warmup_days: "",
                preparation_days: "86",
                total_contacted_contacts: total_contacted_contacts,
                total_email_sent: total_email_sent,
                total_meetings: total_meetings,
                meeting_rate: meeting_rate.toFixed(2),
                total_amount: total_amount
            })
          }
          //Fin Calculos para los totales o resultados, para la ultima final

          this.orders = response.result.map( el => {
            return {
              ...el,
              cashable_margin: (el.cashable_margin) ? el.cashable_margin + ' %' : '',
              operating_margin: (el.operating_margin) ? el.operating_margin + ' %' : '',
              global_margin: (el.global_margin) ? el.global_margin + ' %' : ''
            }
          });

          const orderIds = response.result
            .map((el) => el.id)
            .filter((id) => id !== "" && id != null && id !== undefined);

          if (orderIds.length === 0) {
            this.loading = false;
            return;
          }

          this.getColdTaskByOrders(orderIds);
        } else {
          this.loading = false;
        }
      })
        .catch((error) => {
          console.log("Error loading orders:", error);
          this.loading = false;
        });
    },
    editOrder(index) {
      this.$router.push("/orders/" + index);
    },

    filter(event) {
      this.filters = event;
      this.loadOrders(this.orderStatus, this.filters);
    },

    openTarget(order_id) {
      let url = "/orders/" + order_id;
      window.open(url, "_blank");
    },
    openClient(client_id) {
      let url = "/clients/" + client_id;
      window.open(url, "_blank");
    },

    openComments(orderId) {
      const order = this.orders.find(o => String(o.id) === String(orderId));
      if (!order) return;
      this.selectedOrderForComments = { ...order, client_name: order.target_name || order.client_name };
      this.commentsNotes = [];
      this.commentsModalVisible = true;
      this.commentsLoading = true;
      targetsService.getPerformanceNotes(orderId)
        .then((res) => {
          this.commentsNotes = Array.isArray(res) ? res : (Array.isArray(res && res.result) ? res.result : []);
          this.commentsLoading = false;
        })
        .catch(() => {
          this.commentsNotes = [];
          this.commentsLoading = false;
        });
    },

    publishNote(message) {
      if (!this.selectedOrderForComments || !(message || '').trim()) return;
      const orderId = this.selectedOrderForComments.id;
      targetsService.createPerformanceNote(orderId, (message || '').trim())
        .then(() => {
          // Marcar el icono como ok
          this.orders = this.orders.map(o => {
            if (String(o.id) === String(orderId)) {
              return { ...o, time_warning: '0' };
            }
            return o;
          });
          return targetsService.getPerformanceNotes(orderId);
        })
        .then((res) => {
          this.commentsNotes = Array.isArray(res) ? res : (Array.isArray(res && res.result) ? res.result : []);
        })
        .catch((err) => {
          console.error('Error saving note:', err);
        });
    },
  },
};
</script>

<style scoped>
.banner {
  border-radius: 25em !important;
  color: #fff;
  font-size: 0.75em;
  text-align: left;
  margin-left: 1em;
  margin-right: 1em;
  margin-bottom: 0.2em;
  padding-top: 0.5em;
  padding-bottom: 0.5em;
  background-color: #4d4deb;
  width: 98%;
}

.banner-message {
  margin-left: 2em;
  margin-right: 2em;
}
</style>
